import _extends from "@babel/runtime/helpers/extends";
import { Box } from '@wix/design-system';
import React from 'react';
import { getWdsSurfaceNeutralProps } from '../../../utils/wds-theme-colors';
export const RuleHelperLayout = _ref => {
  let {
    children,
    backgroundColor,
    padding = '8px SP2',
    useSurfaceNeutral = true
  } = _ref;
  const surfaceProps = useSurfaceNeutral ? getWdsSurfaceNeutralProps() : {
    backgroundColor: backgroundColor ?? 'B60'
  };
  return /*#__PURE__*/React.createElement(Box, _extends({
    borderRadius: "6px",
    padding: padding
  }, surfaceProps), children);
};
//# sourceMappingURL=rule-helper-layout.js.map